import type { HealthNode } from "@tanstack/db";
import { ApiError } from "@softmax/observatory-client/transport";
import { collectionError } from "../data/index";

export function communityAccess(health: readonly (HealthNode | undefined)[]) {
  const denial =
    health
      .map(collectionError)
      .find(
        (error) =>
          error instanceof ApiError && [401, 403, 404].includes(error.status),
      ) ?? null;
  return { accessLost: denial !== null, error: denial };
}
